import { Store, createStore, applyMiddleware } from 'redux'
// This provides a Redux middleware which connects to our `react-router` instance.
import { routerMiddleware } from 'connected-react-router'
// We'll be using Redux Devtools. We can use the `composeWithDevTools()`
// directive so we can pass our middleware along with it
import { composeWithDevTools } from 'redux-devtools-extension'
// If you use react-router, don't forget to pass in your history type.
import { History } from 'history'
import logger from 'redux-logger';
import thunk from "redux-thunk"

// Import the state interface and our combined reducers/sagas.
import { ApplicationState, createRootReducer } from './rootReducer'

export default function configureStore(history: History, initialState: ApplicationState): Store<ApplicationState> {
    // create the composing function for our middlewares
    const composeEnhancers = composeWithDevTools({})
    const middlewares = process.env.NODE_ENV === 'development' 
        ? [logger, thunk, routerMiddleware(history)]
        : [thunk, routerMiddleware(history)];
    const middleware = composeEnhancers(applyMiddleware(...middlewares));

    // We'll create our store with the combined reducers/sagas, and the initial Redux state that
    // we'll be passing from our entry point.
    const store = createStore(createRootReducer(history), initialState, middleware);

    return store
}
